import React from "react";
import classes from "./FormCard.module.scss";
import CardText from "./CardText.tsx";
import Form from "./Form.tsx";

const FormCard: React.FC<{
  title?: string;
  subtitle?: string;
  message?: string;
  buttonText?: string;
  id?: string;
  labels? :string[]
  top?: number
}> = ({ title, subtitle, message, buttonText, id, labels, top }) => {
  return (
    <div className={classes["form-card"]} id={id || "contact"}>
      <CardText
        title={title}
        subtitle={subtitle}
        message={message}
        buttonText={buttonText}
      />
      <Form buttonText={buttonText} labels={labels} top={top}/>
    </div>
  );
};

export default FormCard;
